module.exports = __webpack_public_path__ + "img/img-4.a5afd554.png";